"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DateValues_1 = require("../../utilities/dateValues/DateValues");
exports.DayOfWeek = DateValues_1.DayOfWeek;
exports.FirstWeekOfYear = DateValues_1.FirstWeekOfYear;
exports.DateRangeType = DateValues_1.DateRangeType;
//# sourceMappingURL=Calendar.types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Calendar/Calendar.types.js
// module id = 756
// module chunks = 0